export const checkTauriPresentSync = () => {
  // 1. Check build-time flag from Vite (most reliable for app startup)
  if (import.meta.env.VITE_IS_DESKTOP === 'true') return true;

  if (typeof window === 'undefined') return false;

  // 2. Check for Tauri v2 internals
  if (window.__TAURI_INTERNALS__ || window.__TAURI__) return true;

  // 3. Check for Tauri v1 global
  if (window.__tauri__) return true;

  // 4. Check for Tauri-specific protocol (very reliable in production)
  const protocol = window.location.protocol;
  if (
    protocol === 'tauri:' ||
    (protocol === 'http:' && window.location.hostname === 'tauri.localhost')
  ) {
    return true;
  }

  // 5. Fallback to User Agent
  if (navigator.userAgent.includes('Tauri')) return true;

  return false;
};

export const isDesktop = checkTauriPresentSync();
